import React from 'react'
import PropTypes from 'prop-types'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="logo">
            <span className="icon fa-heart"></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>Waterfall Humanitarian Foundation</h1>
                <p>Our Mission to Save, Preserve and Uplift.</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="#disable" onClick={() => {props.onOpenArticle('welcome')}}>Welcome</a></li>
                <li><a href="#disable" onClick={() => {props.onOpenArticle('mission')}}>Mission</a></li>
                <li><a href="#disable" onClick={() => {props.onOpenArticle('org')}}>Organization</a></li>
                <li><a href="#disable" onClick={() => {props.onOpenArticle('projects')}}>Achievements</a></li>
                <li><a href="#disable" onClick={() => {props.onOpenArticle('images')}}>Images</a></li>
                <li><a href="#disable" onClick={() => {props.onOpenArticle('donations')}}>Donate Here</a></li>
                <li><a href="#disable" onClick={() => {props.onOpenArticle('reports')}}>Reports</a></li>
                <li><a href="#disable" onClick={() => {props.onOpenArticle('contact')}}>Contact</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
